<template>
  <div>
    <v-container
      light
      :fluid="$vuetify.breakpoint.smAndDown"
      class="main-chat-box black--text"
    >
      <metax-message
        v-for="(message, index) in messages"
        :key="index"
        :message="message"
      ></metax-message>
    </v-container>
    <writing-box></writing-box>
  </div>
</template>

<script>
import { mapState } from "vuex";
import WritingBox from "./WrittingBox";
import MetaxMessage from "./Message";
export default {
  components: { WritingBox, MetaxMessage },
  name: "MetaxChat",
  computed: {
    ...mapState("inspections", ["inspectionProfile"]),
    messages() {
      return this.inspectionProfile?.messages;
    }
  }
};
</script>

<style>
.main-chat-box {
  background-color: #f4f6fc;
  min-height: 70vh;
  max-height: 70vh;
  overflow-y: auto;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
</style>
